import React from 'react'

export const DeleteIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='22' viewBox='0 0 28 22'>
      <path
        fill='#770358'
        d='M13.989 2A7.99 7.99 0 0 0 6 9.99 7.99 7.99 0 1 0 13.989 2zm3.435 10.154l-1.273 1.27s-2.013-2.16-2.163-2.16c-.148 0-2.162 2.16-2.162 2.16l-1.273-1.27s2.162-1.984 2.162-2.16c0-.18-2.162-2.165-2.162-2.165l1.273-1.274s2.03 2.162 2.162 2.162c.133 0 2.163-2.162 2.163-2.162l1.273 1.274s-2.163 2.013-2.163 2.164c0 .144 2.163 2.16 2.163 2.16z'
      />
    </svg>
  )
}
